import axios from "axios";
import * as Sentry from "@sentry/browser";
import Navigator from "../mixins/navigator/navigator";

const axiosInstance = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "x-debug": true,
  },
});
/**
 * Handle redirectResponses from api.
 */
axiosInstance.interceptors.response.use(
  (response) => {
    Navigator.handleRedirectResponse(response);
    return response;
  },
  (error) => {
    if (error.toJSON) {
      const errJson = error.toJSON();
      Sentry.captureException(
        error.message,
        {
          extra: {
            error: {
              message: errJson.message,
              url: errJson.config.url,
              method: errJson.config.method,
            },
            request_headers: errJson.config.headers,
            request_body: errJson.config.data,
            response_headers: error.response.headers,
            response_body: error.response.request.response,
          },
        },
      );
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
